<div
  class="container"
  [ngClass]="{ 'custom-search-field': tableConfig.showCustomSearchField }"
>
  <span class="search-span">
    <modus-text-input
      label="Search"
      *ngIf="tableConfig.showSearchBar"
      type="text"
      include-search-icon
      class="icon-size"
      (mousedown)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      (keyup)="applyFilter($event)"
      placeholder="{{ 'search' | translate }}"
    >
    </modus-text-input>
  </span>

</div>
<div class="table-container">
  <div class="table-pagination">
    <div
      class="table-content"
      [ngStyle]="{ 'height.%': tableConfig.contentHeight }"
      infiniteScroll
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="50"
      (scrolled)="onScroll($event)"
      [scrollWindow]="false"
      #tableComponent
    >
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        multiTemplateDataRows
        class="mat-elevation-z8"
        (matSortChange)="pageDataChange()"
        [ngClass]="{
          'table-responsive': !isWebView
        }"
      >
        <ng-container
          *ngIf="tableConfig.showCheckbox"
          matColumnDef="commonCheckBoxSelect"
        >
          <th mat-header-cell *matHeaderCellDef>
            <ng-container *ngIf="tableConfig.headerCheckbox">
              <modus-checkbox
                (checkboxClick)="checkBoxHeaderEvent($event)"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [aria-label]="checkboxLabel()"
              >
              </modus-checkbox>
            </ng-container>
          </th>
          <td mat-cell *matCellDef="let row" style="padding: 10px !important">
            <modus-checkbox
              (checkboxClick)="checkBoxEvent($event, row, selection)"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row) && !row?.isCheckboxDisabled"
              [aria-label]="checkboxLabel()"
              [disabled]="row?.isCheckboxDisabled"
            >
            </modus-checkbox>
          </td>
        </ng-container>

        <ng-container
          *ngFor="
            let columnName of tableConfig.displayedColumnNames;
            let i = index
          "
        >
          <ng-container
            *ngIf="
              columnName != 'commonCheckBoxSelect' &&
              columnName != 'actionColumn'
            "
            matColumnDef="{{ columnName }}"
          >
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              [ngClass]="{
                rightAlignValue:
                  tableConfig.rightAlignColumnName.indexOf(columnName) > -1
              }"
            >
              {{ columnName | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              [ngClass]="{
                rightAlignValue:
                  tableConfig.rightAlignColumnName.indexOf(columnName) > -1
              }"
              [title]="columnName === tableConfig.imageColumnName ? '' : element[columnName]"
            >
              <ng-container
                *ngIf="
                  tableConfig.iconColumnName &&
                    columnName == tableConfig.iconColumnName &&
                    element['iconName'];
                  else textColumn
                "
              >
                <span class="iconSize">
                  <i class="modus-icons" aria-hidden="true">{{
                      element["iconName"]
                    }}</i>
                </span>
                <span class="iconColumn">
                  {{ element[columnName] }}
                </span>
              </ng-container>
              <ng-template #textColumn>
                <ng-container *ngIf="isFilePropertyKeyColumn(columnName); else qualityOrText">
                <ng-container *ngIf="getPropertyValues(columnName, element) as propertyValues">
                    <ng-container *ngIf="propertyValues.length > 0">
                        <modus-tooltip
                          [text]="isPanelOpen || propertyValues.length === 1 ? propertyValues.join(', ') : propertyValues[0]"
                          position="top">
                          <modus-chip
                            [value]="propertyValues[0] | translate"
                            size="small"
                            [attr.max-width]="isPanelOpen ? '25px' : '40px'"
                            [attr.title]="''">
                          </modus-chip>
                        </modus-tooltip>
                        <ng-container *ngIf="!isPanelOpen && propertyValues.length > 1">
                          <modus-tooltip
                            [text]="propertyValues.slice(1).join(', ')"
                            position="top"
                            style="width: 30px;">
                            <modus-chip
                              class="count"
                              size="small"
                              [value]="'+' + (propertyValues.length - 1)"
                              max-width="50px"
                              [attr.title]="''">
                            </modus-chip>
                          </modus-tooltip>
                        </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #qualityOrText>
                  <ng-container *ngIf="columnName === tableConfig.imageColumnName; else plainText">
                    <ng-container *ngFor="let issue of getIssueList(element)">
                      <modus-tooltip [text]="issue | translate" position="top">
                        <span><img [src]="getIssueImagePath(issue)" [alt]="issue | translate" class="quality-icon-img"></span>
                      </modus-tooltip>
                    </ng-container>
                  </ng-container>
                  <ng-template #plainText>
                    {{ element[columnName] }}
                  </ng-template>
                </ng-template>
              </ng-template>
            </td>
          </ng-container>
        </ng-container>

        <ng-container
          *ngIf="tableConfig.actionMenuList.length > 0"
          matColumnDef="actionColumn"
        >
          <ng-container *ngIf="isWebView; else actionMenu">
            <th
              mat-header-cell
              *matHeaderCellDef
              [ngStyle]="{ 'width.px': tableConfig.actionMenuList.length * 40 }"
            ></th>
            <td mat-cell *matCellDef="let row">
              <ng-container
                *ngIf="actionInProgress && row === selectedRowId; else actionList"
              >
                <modus-spinner size="1rem" class="table-spinner"></modus-spinner>
              </ng-container>
              <ng-template #actionList>
                <ng-container
                  *ngFor="let actionItem of tableConfig.actionMenuList"
                >
                  <ng-container
                    *ngIf="
                    actionItem['menuName'] === 'Preview' && !row.canPreview;
                    else defaultItem
                  "
                  >
                    <span class="actionIcon" (click)="$event.stopPropagation()">
                      <i
                        class="modus-icons disabled-preview-icon"
                        aria-hidden="true"
                      >{{ actionItem["iconName"] }}</i>
                    </span>
                  </ng-container>
                  <ng-template #defaultItem>
                  <span
                    class="actionIcon"
                    title="{{ actionItem['translationKey'] | translate }}"
                    (click)="
                      $event.stopPropagation();
                      doAction(row, actionItem['menuName'])
                    "
                  >
                    <modus-tooltip [text] = "actionItem['translationKey'] | translate" position="top">
                    <i
                      class="modus-icons"
                      aria-hidden="true"
                      [ngStyle]="{ color: actionItem['iconColor'] }"
                      title=""
                    >{{ actionItem["iconName"] }}</i
                    >
                    </modus-tooltip>
                  </span>
                  </ng-template>
                </ng-container>
              </ng-template>
            </td>
          </ng-container>
          <ng-template #actionMenu>
            <th mat-header-cell
                *matHeaderCellDef
                [ngStyle]="{ 'width.px': 50 }"></th>
            <td mat-cell *matCellDef="let row">
              <ng-container>
                <button mat-icon-button [matMenuTriggerFor]="mainMenu" (click)="$event.stopPropagation()">
                  <i class="modus-icons" aria-hidden="true">more_vertical</i>
                </button>

                <mat-menu #mainMenu="matMenu">

                  <ng-container *ngFor="let actionItem of tableConfig.actionMenuList">

                    <ng-container *ngIf="actionItem['menuName'] !== 'Preview' || row.canPreview">

                      <button
                        mat-menu-item
                        (click)="$event.stopPropagation();
                      doAction(row, actionItem['menuName'])">

                        <i
                          class="modus-icons"
                          aria-hidden="true"
                          [ngStyle]="{ color: actionItem['iconColor'] }"
                        >
                          {{ actionItem["iconName"] }}
                        </i>

                        <span class="menu-content">
                        {{ actionItem['translationKey'] |translate }}
                      </span>

                      </button>

                    </ng-container>

                  </ng-container>

                </mat-menu>

              </ng-container>
            </td>
          </ng-template>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="
            tableConfig.displayedColumnNames;
            sticky: tableConfig.stickyHeader
          "
        ></tr>
        <ng-container
          *ngIf="
            tableConfig.rowClickAction &&
            tableConfig.contextMenuDetails.length > 0
          "
        >
          <tr
            (contextmenu)="onContextMenu($event, element)"
            mat-row
            *matRowDef="let element; columns: tableConfig.displayedColumnNames"
            [ngClass]="
              selection.isSelected(element)
                ? 'selectedColor pointer'
                : 'hoverColor pointer'
            "
            (click)="rowOnClick(element)"
          ></tr>
        </ng-container>
        <ng-container
          *ngIf="
            !tableConfig.rowClickAction &&
            tableConfig.contextMenuDetails.length > 0
          "
        >
          <tr
            (contextmenu)="onContextMenu($event, element)"
            mat-row
            *matRowDef="let element; columns: tableConfig.displayedColumnNames"
            [ngClass]="
              selection.isSelected(element) ? 'selectedColor' : 'hoverColor'
            "
          ></tr>
        </ng-container>
        <ng-container
          *ngIf="
            tableConfig.rowClickAction &&
            tableConfig.contextMenuDetails.length === 0
          "
        >
          <tr
            mat-row
            *matRowDef="let element; columns: tableConfig.displayedColumnNames"
            [ngClass]="
              selection.isSelected(element)
                ? 'selectedColor pointer'
                : 'hoverColor pointer'
            "
            (click)="rowOnClick(element)"
          ></tr>
        </ng-container>
        <ng-container
          *ngIf="
            !tableConfig.rowClickAction &&
            tableConfig.contextMenuDetails.length === 0
          "
        >
          <tr
            mat-row
            *matRowDef="let element; columns: tableConfig.displayedColumnNames"
            [ngClass]="
              selection.isSelected(element) ? 'selectedColor' : 'hoverColor'
            "
          ></tr>
        </ng-container>
      </table>
      <div *ngIf="!tableData" class="spinner-style">
        <modus-spinner size="5rem"></modus-spinner>
      </div>
      <div *ngIf="tableData && tableData.length < 1" class="noItem">
        {{ "noData" | translate }}
      </div>
    </div>
    <ng-container *ngIf="tableConfig.pagination">
      <ng-container
        *ngIf="
          tableConfig.showPaginationFirstLastButtons;
          else noShowFirstLastButtons
        "
      >
        <mat-paginator
          [pageSizeOptions]="tableConfig.pageSizeOptions"
          (page)="pageDataChange()"
          showFirstLastButtons
        ></mat-paginator>
      </ng-container>
      <ng-template #noShowFirstLastButtons>
        <mat-paginator
          [pageSizeOptions]="tableConfig.pageSizeOptions"
          (page)="pageDataChange()"
        >
        </mat-paginator>
      </ng-template>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="tableConfig.contextMenuDetails.length > 0">
  <div
    style="visibility: hidden; position: fixed"
    [style.left]="contextMenuPosition.x"
    [style.top]="contextMenuPosition.y"
    [matMenuTriggerFor]="contextMenu"
  ></div>
  <mat-menu #contextMenu="matMenu">
    <ng-template matMenuContent let-item="item">
      <ng-container *ngFor="let menu of tableConfig.contextMenuDetails">
        <button
          mat-menu-item
          (click)="onContextMenuAction(item, menu.menuName)"
        >
          <i
            class="modus-icons"
            [ngStyle]="{ color: menu['iconColor'] }"
            aria-hidden="true"
          >{{ actionItem["iconName"] }}</i
          >
          <span style="margin-left: 20px; font-size: 14px">{{
              menu.translationKey | translate
            }}</span>
        </button>
      </ng-container>
    </ng-template>
  </mat-menu>
</ng-container>
